<template>
  <md-card class="side-panel-card layout-padding-none">
    <md-toolbar class="layout-gray-dark layout-padding-small">
      <h3 class="md-title">
        <md-icon
          :md-src="`/img/cloud-sun-rain-solid.svg`"
          class="chart-icon"
        />
        Climate Change
      </h3>
      <md-button
        class="md-icon-button md-mini"
        @click="closeSidebar"
      >
        <md-icon>close</md-icon>
      </md-button>
    </md-toolbar>
    <md-card-content>
      <scenario-climate
        :scenario="scenario"
        :show-title="false"
        :show-video-layer="true"
      />
    </md-card-content>
  </md-card>
</template>

<script>
import { mapActions } from "vuex";
import { types } from "@/store/types";
import ScenarioClimate from "./ScenarioClimate";
export default {
  name: "ClimateDetails",

  components: {
    ScenarioClimate
  },

  props: {
    scenario: {
      type: Object,
      default: function () {
        return {};
      },
    }
  },

  data: function () {
    return {
    };
  },

  computed: {
  },

  methods: {
    ...mapActions([
      types.actions.CLOSE_SIDEBAR_CONTENT,
    ]),

    closeSidebar() {
      // trigger panel close
      this.CLOSE_SIDEBAR_CONTENT();
    }
  }

};
</script>
<style lang="scss" scoped>
.side-panel-card {
  height: 100%;
}
.text-white {
  color: $white-color;
}
.md-toolbar {
  box-shadow: none !important;
  .md-title {
    flex: 1;

    :first-child {
      margin-right: 1em;
    }

    .md-icon {
      color: white;
    }
  }
  .md-button {
    box-shadow: none !important;
    background: none !important;
  }
}
</style>